import { render } from "./fund.vue?vue&type=template&id=c5771bd2&scoped=true"
import script from "./fund.vue?vue&type=script&lang=js"
export * from "./fund.vue?vue&type=script&lang=js"

import "./fund.vue?vue&type=style&index=0&id=c5771bd2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5771bd2"]])

export default __exports__